import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createBlock(_component_q_radio, _mergeProps({
    "model-value": _ctx.stringValue,
    val: _ctx.val
  }, _ctx.$attrs, { onClick: _ctx.open }), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.humanValue), 1)
      ], 512), [
        [_vShow, _ctx.humanValue]
      ])
    ]),
    _: 1
  }, 16, ["model-value", "val", "onClick"]))
}